import {
  BeginSealDeviceMethodInterceptor, DeviceProtocolDeviceMethodInterceptor,
  OperationDeviceMethodInterceptor
} from "@hybird/device/interceptor/beginSeal/core";
import {isSupport, xda} from "@hybird/flutter/index";
import {permissions} from "@hybird/flutter/bridge/core";
import {DeviceEvent} from "@hybird/core/device/protocol";
import {defaultError, WebError} from "@hybird/core/error";

let connectId;
const start = async (self) => {
  let _connectId = (connectId += 1);
  const disconnect = () => {
    console.log('visibilityChange disconnect', document?.hidden, self.deviceInfo.visibilityChange)
    if (document?.hidden && !self.deviceInfo.visibilityChange) {
      self.disconnect({type: 7});
    }
  }

  const foreground = !!self.foreground;
  const sealDiscern = self.deviceInfo.sealDiscern === 1
  //异常监听, 开启范围识别功能无法后台运行,
  if (sealDiscern || !foreground || isIOS()) {
    document.addEventListener('visibilitychange', disconnect)
  }

  self.once(DeviceEvent.USER_LOGOUT, () => {
    if (_connectId === connectId) {
      document.removeEventListener('visibilitychange', disconnect)
    }
  });
}

function isIOS() {
  const u = navigator.userAgent;
  return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
}

const check = async (self) => {
  if (isSupport()) {
    if (self.deviceInfo.camera) {
      const camera = await xda.requestPermission(permissions.camera)
      if (!camera.isGranted) {
        throw WebError.code(defaultError.NOT_PERMISSION, {
          msg: "摄像头权限未授权, 请前往设置授权",
        })
      }
    }

    await xda.checkLocation()
  }
}

export class VisibilityChangeDeviceProtocolDeviceMethodInterceptor extends DeviceProtocolDeviceMethodInterceptor {
  async connect(proceed, self, params = {}) {
    await check(self);
    await start(self);

    return proceed(params);
  }

  get order() {
    return 60;
  }

  isSupport(deviceBeginSeal) {
    return true;
  }
}

export class VisibilityChangeBeginSealDeviceMethodInterceptor extends BeginSealDeviceMethodInterceptor {
  async connect(proceed, self, params = {}) {
    await check(self);
    return proceed(params);
  }

  async beginSeal(proceed, self, params = {}) {
    if (isSupport()) {
      if (self.deviceInfo.camera) {
        const camera = await xda.requestPermission(permissions.camera)
        if (!camera.isGranted) {
          throw WebError.code(defaultError.NOT_PERMISSION, {
            msg: "摄像头权限未授权, 请前往设置授权",
          })
        }
      }

      await xda.checkLocation()
    }

    await check(self);
    return proceed(params);
  }

  get order() {
    return 60;
  }

  isSupport(deviceBeginSeal) {
    return true;
  }
}

export class VisibilityChangeOperationDeviceMethodInterceptor extends OperationDeviceMethodInterceptor {
  async beginSeal(proceed, self, params = {}) {
    return proceed(params);
  }

  get order() {
    return 60;
  }

  isSupport(deviceProtocolOperation) {
    return true;
  }
}